import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { CreateGroupData, GroupList } from "@/builders/types/group";
import { id } from "./id";

const get = function (params?: FilterParams) {
  return api.get<GroupList>("groups", { params }).then(({ data }) => data);
};

const post = function (data: CreateGroupData) {
  return api
    .post<{
      data: CreateGroupData;
    }>("groups", data)
    .then(({ data }) => data);
};

export const groups = {
  get,
  post,
  id,
};
